import { render, staticRenderFns } from "./ConstellationPage.vue?vue&type=template&id=141848f8&"
import script from "./ConstellationPage.vue?vue&type=script&lang=js&"
export * from "./ConstellationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports